import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationContextBoundComponent } from 'src/app/shared/components';

@Component({
    selector: 'tpo-corr-icd-request',
    templateUrl: 'tpo-corr-icd-request.component.html',
    standalone: false
})
export class TpoCorrIcdRequestComponent extends ApplicationContextBoundComponent implements OnInit, OnDestroy {
  isTpo: boolean = false;

  private readonly _contextSubscription: Subscription;

  constructor(private readonly injector: Injector) {
    super(injector);
    this.isTpo = this.applicationContext.isTpo;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._contextSubscription?.unsubscribe();
  }
}
